import request from '../request'
import { util } from '@/util'

const path='/resume-api/'
const pathInitMenu1='getResume'
const pathInitMenu2='saveResume'
const pathInitMenu3='getPostInfo'
const pathInitMenu4='selectMyApply'

//签名密钥：与后端application.properties中的brProvideSignKey保持一致。
const SIGN_KEY='f20f423172dc5f4433bf40a490d461ef'

// 构造带签名的请求体。[2026-09-03] 身份证号、姓名不再由前端传递，后端凭登录态token反查登录人身份。
function signedBody(){
    const body={
        REQUESTTIME:util.formatTime().split(' ')[0],
        timestamp:util.formatTimeCompact(),
    }
    body.sign=util.genSign(body,SIGN_KEY)
    return body
}

// 获取招聘信息(已申请岗位)
export const getResume =function () {
    return request.post(`${path}${pathInitMenu1}`,signedBody())
}

//获取提交信息
export const submitgetrs =function () {
    return request.post(`${path}${pathInitMenu1}`,signedBody())
}

// 提交应聘信息
export const saveResume =function (data) {
    return request.post(`${path}${pathInitMenu2}`,{
       ...data,
       REQUESTTIME:util.formatTime().split(' ')[0],
    })
}

// 获取岗位信息
export const getPostInfo =function (FPOSTNO,FPOSTNAME,FDEPTNO,FDEPTNAME) {
    return request.post(`${path}${pathInitMenu3}`,{
        FPOSTNO:FPOSTNO,
        FPOSTNAME:FPOSTNAME,
        FDEPTNO:FDEPTNO,
        FDEPTNAME:FDEPTNAME,
    })
}

// 查询某岗位提交的个人信息
export const getMyApplyInfo =function (FIDCARDNO) {
    return request.post(`${path}${pathInitMenu4}`,{
        FIDCARDNO:FIDCARDNO,//身份证号
    })
}
